// Libs
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _debounce from 'lodash/debounce'
import _filter from 'lodash/filter'
import _tail from 'lodash/tail'
import _size from 'lodash/size'

// Components
import SearchInput from './SearchInput'
import LocationSearchResults from './LocationSearchResults'
import SearchIndicator from './SearchIndicator'

// Constants
import {
  CITY_SEARCH_URL,
  CITY_SEARCH_QUERY_REST,
} from '../constants'

// Regular Expression
const regexpLatLng = /(-*\d+[.\d+]*)[ ,]+(-*\d+[.\d+]*)/

// City Search
export default class LocationSearch extends Component {
  constructor () {
    super()

    this.state = {
      term: '',
      results: [],
      searching: [],
    }

    this.search = this.search.bind(this)
    this.onChangeInput = this.onChangeInput.bind(this)
    this.onSelectResult = this.onSelectResult.bind(this)
    this.onSearch = _debounce(this.onSearch.bind(this), 250)
  }

  componentDidMount () {
    this._isMounted = true
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  search () {
    const { term } = this.state
    const url = `${CITY_SEARCH_URL}${term}${CITY_SEARCH_QUERY_REST}`

    fetch(url).then((response) => {
      response.json().then((results) => {
        if (this._isMounted) {
          this.setState({
            results: _filter(results, { class: 'place' }),
            searching: _tail(this.state.searching),
          })
        }
      })
    })
  }

  isSearching () {
    return _size(this.state.searching) > 0
  }

  onChangeInput ({target}) {
    this.setState({
      term: target.value,
    }, this.onSearch)
  }

  onSearch () {
    const { term } = this.state

    if (this.props.latlng) {
      const match = `${term}`.match(regexpLatLng)
      if (match) {
        const [, lat, lng] = match
        this.props.onZoomToLatLng({lat, lng})
      }
    } else if (term && term.length > 4) {
      this.setState({
        searching: [...this.state.searching, true],
      }, this.search)
    } else {
      this.setState({
        results: [],
      })
    }
  }

  onSelectResult (result) {
    const {
      boundingbox,
      lat,
      lon: lng,
    } = result

    if (boundingbox) {
      const [minY, maxY, minX, maxX] = boundingbox
      this.props.onZoomToBounds([
        [minY, minX],
        [maxY, maxX],
      ])
    } else {
      this.props.onZoomToLatLng({lat, lng})
    }
  }

  render () {
    return (
      <div data-test='LocationSearch'>
        <div style={{
          display: 'flex',
        }}>
          <SearchInput
            value={this.state.term}
            onInput={this.onChangeInput}
            placeholder={this.props.latlng ? 'e.g. 50.1, -114.5' : 'e.g. Toronto'}
          />
        </div>
        {this.isSearching() ? (
          <SearchIndicator />
        ) : null}
        <LocationSearchResults
          results={this.state.results}
          onSelectResult={this.onSelectResult}
        />
      </div>
    )
  }
}

LocationSearch.propTypes = {
  latlng: PropTypes.bool,
  onZoomToLatLng: PropTypes.func.isRequired,
  onZoomToBounds: PropTypes.func.isRequired,
}
